import Vue, { VueConstructor } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { i18n } from "./plugins/vue-i18n";
import VueMask from "v-mask";

import "./filters/basicDate";
import "./filters/dateName";

import "./plugins/animate";
import "./plugins/arch-confirm";
import "./plugins/parseURL";
import "./plugins/arch-set-title";
import "./plugins/clipboard";
import "./plugins/vue-apexchart";
import "./filters/capitalize";
import "./filters/lowercase";
import "./filters/uppercase";
import "./filters/formatCurrency";
import "./directives/uppercase";
import "./filters/formatDate";
import "./filters/formatTime";
import "./assets/scss/theme.scss";
import "animate.css/animate.min.css";
import "typeface-quicksand/index.css";
import socketPlugin from "./services/SignalGo";
import axiosPlugin from "./services/Api";
import archAlertPlugins from "@/plugins/arch-alert";
import archNotifyPlugins from "@/plugins/arch-notify";
import "sentec-vues/modules/service-worker/service/registerServiceWorker";
import { iconPlugin } from "@/plugins/icons";
import "@mdi/font/css/materialdesignicons.min.css";

// Axios errors are already surfaced to the user by the response interceptor's notification.
// A $http call without a .catch() otherwise leaks an unhandled rejection ("Uncaught runtime errors").
// Suppress those globally so we don't need a .catch() on every call; non-axios rejections still surface.
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason as { isAxiosError?: boolean; response?: unknown; message?: string } | undefined;
  if (reason && (reason.isAxiosError || reason.response)) {
    event.preventDefault();
    console.warn("Suppressed unhandled axios rejection (already notified by interceptor):", reason.message ?? reason);
  }
});

Vue.component("ArchItemPicker", ()=> import("./components/common/ArchItemPicker.vue"));
Vue.component("StItemPicker", ()=> import("sentec-vues/components/STItemPicker.vue"));
Vue.component("StItemPickerV2", ()=> import("sentec-vues/components/STItemPickerV2.vue"));
Vue.component("ArchItemPickerV3", ()=> import("./components/common/ArchItemPickerV3.vue"));
Vue.component("ArchItemPickerV4", ()=> import("./components/common/ArchItemPickerV4.vue"));
Vue.component("ArchSelect", ()=> import("./components/common/ArchSelect.vue"));
Vue.component("ArchDataTable", ()=> import("./components/common/ArchDataTable.vue"));
Vue.component("StDataTable", ()=> import("sentec-vues/components/STDataTable.vue"));
Vue.component("ArchDataTableV2", ()=> import("./components/common/ArchDataTableV2.vue"));
Vue.component("StDataTableInfiniteScroll", ()=> import("sentec-vues/components/STDataTableInfiniteScroll.vue"));
Vue.component("StDatePicker", ()=> import("sentec-vues/components/STDatePicker.vue"));
Vue.component("StDatePickerV2", ()=> import("sentec-vues/components/STDatePickerV2.vue"));
Vue.component("StDatePickerV3", ()=> import("sentec-vues/components/STDatePickerV3.vue"));
Vue.component("StDateRangePicker", ()=> import("sentec-vues/components/STDateRangePicker.vue"));
Vue.component("StDateRangePickerFlatten", ()=> import("sentec-vues/components/STDateRangePickerFlatten.vue"));
Vue.component("ArchSelectV2", () => import("./components/common/ArchSelectV2.vue"));
Vue.component("StTimePicker", () => import("sentec-vues/components/STTimePicker.vue"));
Vue.component("StDialog", () => import("sentec-vues/components/STDialog.vue"));
Vue.component("ArchItemLookup", () => import("./components/common/ArchItemLookup.vue"));
Vue.component("StItemLookup", () => import("sentec-vues/components/STItemLookup.vue"));
Vue.component("StNumberInput", () => import("sentec-vues/components/STNumberInput.vue"));
Vue.component("ArchNumberInput", () => import("./components/common/ArchNumberInput.vue"));
Vue.component("ArchUploadReport", () => import("./components/common/ArchUploadReport.vue"));
Vue.component("VNumberField", () => import("./components/common/VNumberField.vue"));
Vue.component("ArchMonthPicker", () => import("./components/common/ArchMonthPicker.vue"));
Vue.component("StDownloadGroup", ()=> import("sentec-vues/components/STDownloadGroup.vue"));
Vue.component("TextFieldCopy", () => import("./components/common/TextFieldCopy.vue"));

//finance related components
Vue.component("ChartOfAccountDetailDialog", () => import("./components/common/ChartOfAccountDetailDialog.vue"));
Vue.component("ArchPreviewDialog", () => import("./components/common/ArchPreviewDialog.vue"));
Vue.component("ArchPreviewListDialog", () => import("./components/common/ArchPreviewListDialog.vue"));
Vue.component("Journals", () => import("./components/common/Journals.vue"));
Vue.component("JournalApplyEntryDialog", () => import("./components/common/JournalApplyEntryDialog.vue"));
Vue.component("CashReceiptJournalApplyEntryDialog", () => import("./components/common/CashReceiptJournalApplyEntryDialog.vue"));
Vue.component("ReconciliationApplyEntryDialog", () => import("./components/common/ReconciliationApplyEntryDialog.vue"));
Vue.component("ConfirmationNoteDialog", () => import("./components/common/ConfirmationNoteDialog.vue"));

Vue.component("StTopActionsList", () => import("./components/common/STTopActionsList.vue"));
Vue.component("StAnnouncementComponent", ()=> import("sentec-vues/modules/announcement/components/StAnnouncementComponent.vue"));
Vue.use(socketPlugin);
Vue.use(axiosPlugin);
Vue.use(archAlertPlugins);
Vue.use(archNotifyPlugins);
Vue.use(iconPlugin);
Vue.use(VueMask);
// Set this to false to prevent the production tip on Vue startup.
Vue.config.productionTip = false;
Vue.config.keyCodes.f9 = 120;
Vue.config.keyCodes.backspace = 8;
export default new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
